module.exports = __webpack_public_path__ + "media/images/partner-alt-4-fa6f74707d3f083bc410766807320831.png";